(function () {
    const TRIGGER = "#BIS_trigger"
    const FRAME_ID = "BIS_frame"
    const PRODUCT_PATH = /\/products\/([^/?#]+)/

    let popover = null

    function currentHandle() {
        const match = PRODUCT_PATH.exec(
            decodeURIComponent(window.location.pathname)
        )
        return match && match[1]
    }

    function discard(stale) {
        if (!stale) return

        document.removeEventListener("click", stale.triggerHandler)

        stale.createUI = function () {}

        if (stale.form && stale.form.frame) stale.form.frame.remove()

        if (stale.button && stale.button.wrap) stale.button.wrap.remove()
    }

    function dedupeFrameStyles() {
        const seen = new Set()

        document.head.querySelectorAll("style").forEach((style) => {
            const css = style.textContent
            if (!css || !css.includes("#" + FRAME_ID)) return

            if (seen.has(css)) {
                style.remove()
                return
            }
            seen.add(css)
        })
    }

    function rebuild() {
        const BIS = window.BIS 

        if (!BIS || typeof BIS.createPopover !== "function") return

        discard(popover || BIS.popup)
        popover = null

        const handle = currentHandle()
        if (!handle || !document.querySelector(TRIGGER)) return

        popover = BIS.createPopover({ productHandle: handle, product: null })
        BIS.popup = popover
        window.BISPopover = popover

        if (popover.ready) popover.ready.then(dedupeFrameStyles)
    }

    document.addEventListener("fabric:swapped", () => {
        try {
            rebuild()
        } catch (error) {
            console.error(error)
        }
    })
})()
